/* eslint-disable @typescript-eslint/naming-convention */
import { VaultCredsType } from '@app/vault/models/enums/vault-creds-type.enum';

export class VaultRowModel {
    saved: boolean = true;      // indicates if ever saved to the API / has a ID from API
    tempId: string;             // temporary uuid for unsaved rows
    id: number | null = null; // unique ID generated by API
    name: string = null;
    expiration: string | null = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- credentials hold dynamic, channel-specific JSON
    credentials: any = {};
    credentials_type: VaultCredsType | null = null;
    oauth_id: string = null;
    refresh_token: string = null;

    constructor(jsonData?: unknown) {

        if (typeof jsonData === 'object' && jsonData !== null) {
            for (const prop in jsonData) {
                if (Object.prototype.hasOwnProperty.call(this, prop)) {
                    (this as Record<string, unknown>)[prop] = (jsonData as Record<string, unknown>)[prop];
                }
            }
        }

    }

    /**
     * Safely parse this record's `credentials` into a typed object.
     *
     * The API returns `credentials` as a JSON string, so it must be parsed
     * before use. Returns null when the credentials are missing or are not
     * valid JSON.
     */
    parseCredentials<T = Record<string, unknown>>(): T | null {
        const credentials: unknown = this.credentials;

        if (!credentials) {
            return null;
        }

        // Defensive: credentials may already be a parsed object (ex: a freshly created record).
        if (typeof credentials === 'object') {
            return credentials as T;
        }

        if (typeof credentials !== 'string') {
            return null;
        }

        try {
            return JSON.parse(credentials) as T;
        } catch {
            return null;
        }
    }

}
